// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ed42836a","528":"4f9920b1","753":"21e17a83","905":"2ca46b33"}[chunkId] + ".chunk.js";
};